// Lightweight toast for transient admin notifications (rate-limit
// errors etc.). No external deps; a single global region listens
// to CustomEvents dispatched via `pushToast()`.
import { useEffect, useState } from "react";

type Toast = { id: number; kind: "info" | "error"; text: string };
const EVENT_NAME = "admin-toast";

export function pushToast(text: string, kind: "info" | "error" = "info") {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent<Toast>(EVENT_NAME, {
      detail: { id: Date.now() + Math.random(), kind, text },
    }),
  );
}

export function ToastRegion() {
  const [items, setItems] = useState<Toast[]>([]);
  useEffect(() => {
    function onToast(e: Event) {
      const t = (e as CustomEvent<Toast>).detail;
      setItems((prev) => [...prev, t]);
      window.setTimeout(() => {
        setItems((prev) => prev.filter((x) => x.id !== t.id));
      }, 5000);
    }
    window.addEventListener(EVENT_NAME, onToast);
    return () => window.removeEventListener(EVENT_NAME, onToast);
  }, []);
  if (items.length === 0) return null;
  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2 pointer-events-none">
      {items.map((t) => (
        <div
          key={t.id}
          className={`pointer-events-auto rounded border px-3 py-2 text-sm shadow-lg ${
            t.kind === "error"
              ? "border-rose-700/50 bg-rose-900/40 text-rose-100"
              : "border-ink-700 bg-ink-900 text-ink-100"
          }`}
        >
          {t.text}
        </div>
      ))}
    </div>
  );
}
